import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'DocumentFormatPipe'
})
export class DocumentFormatPipe implements PipeTransform {
  constructor() {

  }
  transform(value: string): string {
    switch (value.length) {
      case 14:
        return value.substring(0,2)+"."+value.substring(2,5)+"."+value.substring(5,8)+"/"+value.substring(8,12)+"-"+value.substring(12);
      case 11:
        return value.substring(0,3)+"."+value.substring(3,6)+"."+value.substring(6,9)+"-"+value.substring(9);
      default:
        return value;
    }
  }
}
